import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err: any) {
      setError(err.response?.data?.error || 'Ошибка авторизации');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-logo">SakhaVision CRM</div>
        <div className="auth-subtitle">Система управления взаимоотношениями с клиентами</div>

        {error && (
          <div style={{
            padding: '12px 16px',
            background: '#fee2e2',
            color: '#991b1b',
            borderRadius: 'var(--radius-md)',
            marginBottom: 20,
            fontSize: 13,
            fontWeight: 500,
            display: 'flex',
            alignItems: 'center',
            gap: 8
          }}>
            <span>⚠️</span> {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email адрес</label>
            <input
              type="email"
              className="form-input"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="name@company.ru"
              required
            />
          </div>
          <div className="form-group">
            <div className="flex justify-between items-center" style={{ marginBottom: 6 }}>
              <label className="form-label" style={{ marginBottom: 0 }}>Пароль</label>
              <a href="#" style={{ fontSize: 12, color: 'var(--color-primary)', fontWeight: 500 }}>Забыли пароль?</a>
            </div>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          <button type="submit" className="btn btn-primary" style={{ width: '100%', marginTop: 8, height: 44 }} disabled={loading}>
            {loading ? 'Выполняется вход...' : 'Войти в аккаунт'}
          </button>
        </form>
      </div>
    </div>
  );
}
